<template>
  <div>
    <a-modal
      v-model="showModal"
      header
      footer
      :width="windowWidth"
      @cancel="handleModalClose"
      :class="`custom-recommend-modal ${
        reviewComplete ? 'modal-close-btn-white' : ''
      }`"
      @ok="handleModalOk"
      :centered="true"
      :dialog-style="{ margin: '0px' }"
      destroyOnClose="true"
      wrapClassName="modalWrappedClass"
    >
      <div
        v-if="!reviewComplete"
        class="recommend-container"
        :style="{ background: getPrimaryColor() }"
      >
        <div class="blue-part" :style="{ background: getPrimaryColor() }">
          <div
            v-if="selectedDoctorProfile"
            class="blue-content"
            :style="{ width: '300px' }"
          >
            <img
              v-if="getEntityImage()"
              :src="getEntityImage()"
              alt
              class="round"
              :style="{ border: '1px solid #F8FAFD' }"
            />
            <h4 class="white"><strong>You are Reviewing</strong></h4>
            <h1 class="white selected-profile-name mb-5">
              <b>{{ getReviewerLabel() }}</b>
            </h1>
            <a
              :href="`${SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`"
              class="white guidelines hide-in-mobile"
              target="_blank"
              >Guidelines for Reviewing</a
            >
          </div>
        </div>
        <div class="white-container">
          <div class="white-part">
            <div v-if="typeOfReview === 'none'" class="reviewTypeContainer">
              <h1 class="reviewMainHeader">
                How did you interact with this doctor?
              </h1>
              <div
                @click="setTypeOfReview('inPerson')"
                :class="`reviewTypeCard ${checkDisabled('inPerson')}`"
              >
                <h1 class="reviewTypeTitle">In person visit</h1>
                <p class="reviewTypeDescription">
                  Use this review type if you have seen the provider in person
                  for a consultation
                  <font-awesome-icon
                    size="1x"
                    class="nav-tab-icons mr-2"
                    :icon="['far', 'arrow-right']"
                  />
                </p>
              </div>
              <div
                @click="setTypeOfReview('online')"
                :class="`reviewTypeCard ${checkDisabled('online')}`"
              >
                <h1 class="reviewTypeTitle">Online TeleMedicine</h1>
                <div class="reviewTypeDescription">
                  Use this review type if you have consulted the provider using
                  an online TeleMedicine platform
                  <font-awesome-icon
                    size="1x"
                    class="nav-tab-icons mr-2"
                    :icon="['far', 'arrow-right']"
                  />
                </div>
              </div>
              <div
                @click="setTypeOfReview('myCircles')"
                :class="`reviewTypeCard ${checkDisabled('myCircles')}`"
              >
                <h1 class="reviewTypeTitle">MyCircles</h1>
                <p class="reviewTypeDescription">
                  Use this review type based on your interaction with this
                  provider on MyCircles community. This review is not a doctor
                  patient consultation
                  <font-awesome-icon
                    size="1x"
                    class="nav-tab-icons mr-2"
                    :icon="['far', 'arrow-right']"
                  />
                </p>
              </div>
              <h3 class="reviewRightFooter">
                You can only review a physician once per week per each type of
                review
              </h3>
            </div>
            <div v-if="typeOfReview === 'myCircles'">
              <div v-for="(review, ind) in myCircleReviews" :key="ind">
                <div v-if="currentReview === ind">
                  <p class="count">
                    {{ ind + 1 }} of {{ myCircleReviews.length }}
                  </p>
                  <h1 class="review-title">{{ review.heading }}</h1>
                  <p class="rev-desc">{{ review.description }}</p>
                  <div v-if="ind < myCircleReviews.length - 1" class="star-box">
                    <a-icon
                      v-for="i in [1, 2, 3, 4, 5]"
                      :key="i"
                      class="star-rating-recommend"
                      :class="
                        i > myCircleReviews[ind].rating ? 'silver' : 'golden'
                      "
                      type="star"
                      @mouseover="getHover(i, ind)"
                      @mouseleave="removeHover(ind)"
                      @click="putRating(i)"
                      theme="filled"
                    />
                  </div>
                  <h3 v-if="ind < myCircleReviews.length - 1" class="rating">
                    {{ ratingConverter(myCircleReviews[ind].rating) }}
                  </h3>
                  <h3
                    v-if="geth && !ind < myCircleReviews.length - 1"
                    class="rating"
                  >
                    {{ geth }}
                  </h3>
                  <div
                    v-if="ind === myCircleReviews.length - 1"
                    class="text-box"
                  >
                    <a-textarea
                      :placeholder="
                        getReviewInputPlaceholder(selectedDoctorProfile.role)
                      "
                      v-model="myCircleReviews[ind].rating"
                      :rows="6"
                      :maxlength="5000"
                    />
                    <p class="text-right small-text">
                      {{
                        myCircleReviews[ind].rating
                          ? myCircleReviews[ind].rating.length
                          : 0
                      }}/5000
                    </p>
                  </div>
                  <div class="arrows">
                    <a-icon
                      v-if="currentReview > 0"
                      @click="currentReview = currentReview - 1"
                      type="left"
                    />
                    <!-- <a-icon v-if="currentReview > 0 && ind < myCircleReviews.length - 1" @click="currentReview = currentReview + 1" type="right" /> -->
                  </div>
                  <p
                    v-if="ind === myCircleReviews.length - 1"
                    class="small-text text-center gray900 font12 mb-3"
                  >
                    By clicking “Submit” you agree to be at least 18 years old.
                  </p>
                  <button
                    @click="recommend"
                    v-if="ind === myCircleReviews.length - 1"
                    class="dovemed-button font-white w-100 mb-2"
                    :style="{ background: getPrimaryColor() }"
                  >
                    {{ submitting ? "Submitting..." : "Submit" }}
                  </button>
                </div>
              </div>
            </div>
            <div v-if="typeOfReview === 'inPerson'">
              <div v-for="(review, ind) in inPersonReviews" :key="ind">
                <div v-if="currentReview === ind">
                  <p class="count">
                    {{ ind + 1 }} of {{ inPersonReviews.length }}
                  </p>
                  <h1 class="review-title">{{ review.heading }}</h1>
                  <p class="rev-desc">{{ review.description }}</p>
                  <template v-if="review.key === 'length_of_visit'">
                    <div class="d-flex flex-column align-items-center">
                      <button
                        class="br8 p1224 cp mb-3 bg-white visit-btn"
                        @click="handleLengthVisit('lt15')"
                        :style="{
                          border: `1px solid ${getPrimaryColor()}`,
                          color: getPrimaryColor(),
                          'min-width': '200px',
                        }"
                      >
                        Less than 30 minutes
                      </button>
                      <button
                        class="br8 p1224 cp mb-3 bg-white visit-btn"
                        @click="handleLengthVisit('lt30')"
                        :style="{
                          border: `1px solid ${getPrimaryColor()}`,
                          color: getPrimaryColor(),
                          'min-width': '200px',
                        }"
                      >
                        30 - 60 minutes
                      </button>
                      <button
                        class="br8 p1224 cp mb-3 bg-white visit-btn"
                        @click="handleLengthVisit('hour')"
                        :style="{
                          border: `1px solid ${getPrimaryColor()}`,
                          color: getPrimaryColor(),
                          'min-width': '200px',
                        }"
                      >
                        More than an hour
                      </button>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      v-if="ind < inPersonReviews.length - 1"
                      class="star-box"
                    >
                      <a-icon
                        v-for="i in [1, 2, 3, 4, 5]"
                        :key="i"
                        class="star-rating-recommend"
                        :class="
                          i > inPersonReviews[ind].rating ? 'silver' : 'golden'
                        "
                        type="star"
                        @mouseover="getHover(i, ind)"
                        @mouseleave="removeHover(ind)"
                        @click="putRating(i)"
                        theme="filled"
                      />
                    </div>
                    <h3 v-if="ind < inPersonReviews.length - 1" class="rating">
                      {{ ratingConverter(inPersonReviews[ind].rating) }}
                    </h3>
                    <h3
                      v-if="geth && !ind < inPersonReviews.length - 1"
                      class="rating"
                    >
                      {{ geth }}
                    </h3>
                    <div
                      v-if="ind === inPersonReviews.length - 1"
                      class="text-box"
                    >
                      <a-textarea
                        :placeholder="
                          getReviewInputPlaceholder(selectedDoctorProfile.role)
                        "
                        v-model="inPersonReviews[ind].rating"
                        :rows="6"
                        :maxlength="5000"
                      />
                      <p class="text-right small-text">
                        {{
                          inPersonReviews[ind].rating
                            ? inPersonReviews[ind].rating.length
                            : 0
                        }}/5000
                      </p>
                    </div>
                  </template>
                  <div class="arrows">
                    <a-icon
                      v-if="currentReview > 0"
                      @click="currentReview = currentReview - 1"
                      type="left"
                    />
                    <!-- <a-icon v-if="currentReview > 0 && ind < inPersonReviews.length - 1" @click="currentReview = currentReview + 1" type="right" /> -->
                  </div>
                  <p
                    v-if="ind === inPersonReviews.length - 1"
                    class="small-text text-center gray900 font12 mb-3"
                  >
                    By clicking “Submit” you agree to be at least 18 years old.
                  </p>
                  <button
                    @click="recommend"
                    v-if="ind === inPersonReviews.length - 1"
                    class="dovemed-button font-white w-100 mb-2"
                    :style="{ background: getPrimaryColor() }"
                  >
                    {{ submitting ? "Submitting..." : "Submit" }}
                  </button>
                </div>
              </div>
            </div>
            <div v-if="typeOfReview === 'online'">
              <div v-for="(review, ind) in onlineReviews" :key="ind">
                <div v-if="currentReview === ind">
                  <p class="count">
                    {{ ind + 1 }} of {{ onlineReviews.length }}
                  </p>
                  <h1 class="review-title">{{ review.heading }}</h1>
                  <p class="rev-desc">{{ review.description }}</p>
                  <div v-if="ind < onlineReviews.length - 1" class="star-box">
                    <a-icon
                      v-for="i in [1, 2, 3, 4, 5]"
                      :key="i"
                      class="star-rating-recommend"
                      :class="
                        i > onlineReviews[ind].rating ? 'silver' : 'golden'
                      "
                      type="star"
                      @mouseover="getHover(i, ind)"
                      @mouseleave="removeHover(ind)"
                      @click="putRating(i)"
                      theme="filled"
                    />
                  </div>
                  <h3 v-if="ind < onlineReviews.length - 1" class="rating">
                    {{ ratingConverter(onlineReviews[ind].rating) }}
                  </h3>
                  <h3
                    v-if="geth && !ind < onlineReviews.length - 1"
                    class="rating"
                  >
                    {{ geth }}
                  </h3>
                  <div v-if="ind === onlineReviews.length - 1" class="text-box">
                    <a-textarea
                      :placeholder="
                        getReviewInputPlaceholder(selectedDoctorProfile.role)
                      "
                      v-model="onlineReviews[ind].rating"
                      :rows="6"
                      :maxlength="5000"
                    />
                    <p class="text-right small-text">
                      {{
                        onlineReviews[ind].rating
                          ? onlineReviews[ind].rating.length
                          : 0
                      }}/5000
                    </p>
                  </div>
                  <div class="arrows">
                    <a-icon
                      v-if="currentReview > 0"
                      @click="currentReview = currentReview - 1"
                      type="left"
                    />
                    <!-- <a-icon v-if="currentReview > 0 && ind < onlineReviews.length - 1" @click="currentReview = currentReview + 1" type="right" /> -->
                  </div>
                  <p
                    v-if="ind === onlineReviews.length - 1"
                    class="small-text text-center gray900 font12 mb-3"
                  >
                    By clicking “Submit” you agree to be at least 18 years old.
                  </p>
                  <button
                    @click="recommend"
                    v-if="ind === onlineReviews.length - 1"
                    class="dovemed-button font-white w-100 mb-2"
                    :style="{ background: getPrimaryColor() }"
                  >
                    {{ submitting ? "Submitting..." : "Submit" }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          :href="`${SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`"
          class="white guidelines show-in-mobile"
          target="_blank"
          >Guidelines for Reviewing</a
        >
      </div>
      <div
        v-if="reviewComplete"
        class="recommend-container"
        :style="{ background: getPrimaryColor() }"
      >
        <div
          class="blue-part w-100 end-height p-5"
          :style="{ background: getPrimaryColor() }"
        >
          <div v-if="selectedDoctorProfile" class="blue-content reviewDone">
            <img
              v-if="getEntityImage()"
              :src="getEntityImage()"
              alt
              class="round"
              :style="{ border: '1px solid #F8FAFD' }"
            />
            <h1 class="white font24">Thanks for reviewing</h1>
            <h1 class="white fw700">{{ getReviewerLabel() }}</h1>
            <!-- <div class="white-rate-container">
              <h3>Your Rating</h3>
              <div class="primary-dark-background font-white dovemed-button rate-area">
                <a-icon style="color: white" type="star" theme="filled" />
                {{ " " + docRating }}
              </div>
            </div> -->
            <div
              class="d-flex flex-column bg-white br100 align-items-center"
              :style="{ padding: '24px 120px' }"
            >
              <h4 class="gray900 fw700 font24 mb-3">Your Rating</h4>
              <ReviewStar :rating="docRating" :height="30" :width="30" />
              <p class="mb-0 mt-2 gray900 fw700 font20">
                {{ docRating + " stars" }}
              </p>
            </div>
            <button
              @click="handleCloseReview"
              class="close dovemed-button font-white mt-3"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import ReviewStar from "../commons/ReviewStar.vue";

const UserRepository = RepositoryFactory.get("user");

export default {
  components: { ReviewStar },
  name: "RecommendDoctor",
  props: {
    fetchUser: { type: Function, default: () => {} },
    fetchReviews: { type: Function, default: () => {} },
  },
  data() {
    return {
      reviewStarClicked: false,
      submitting: false,
      geth: null,
      showModal: false,
      windowWidth: 1000,
      typeOfReview: "none",
      defaultHospitalImage:
        "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/Hospital.svg",
      defaultClinicImage:
        "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/Clinic.svg",
      defaultNfpImage:
        "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/nfp-icon.svg",
      selectedDoctorProfile: {},
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      finalPopSize: null,
      docRating: 0,
      myCircleReviews: [
        {
          key: "knowledge_ability",
          heading: "Knowledgeability",
          description:
            "How Knowledgeable is the healthcare professional in his/her area of expertise?",
          rating: 0,
        },
        {
          key: "compassion",
          heading: "Compassion",
          description:
            "Does the healthcare professional show care and concern while interacting on the platform?",
          rating: 0,
        },
        {
          key: "supportive",
          heading: "Supportive",
          description:
            "Do you find the healthcare professonal to be supportive and understanding?",
          rating: 0,
        },
        {
          key: "easy_to_interact_with",
          heading: "Easy to interact with",
          description:
            "Is the healthcare professional easy to interact with on the platform?",
          rating: 0,
        },
        {
          key: "empathy",
          heading: "Empathy",
          description:
            "Does the healthcare professional recognize the feelings of others?",
          rating: 0,
        },
        {
          key: "active_on_the_platform",
          heading: "Active on the platform",
          description:
            "Is the healthcare professional very active on the platform and frequently interacts with the participants?",
          rating: 0,
        },
        {
          key: "description",
          heading: "Few words can be really powerful",
          description: " - OPTIONAL",
          rating: null,
        },
      ],
      inPersonReviews: [
        // {
        //   // key: "ease_of_appointment",
        //   key: "appointment",
        //   heading: "Ease of Appointment",
        //   description: "How easy was is to schedule an appointment?",
        //   rating: 0,
        // },
        // {
        //   key: "wait_time",
        //   heading: "Wait Time",
        //   description: "How satisifed were you about the wait time before seeing a doctor?",
        //   rating: 0,
        // },
        // {
        //   key: "friendliness_of_staff",
        //   heading: "Friendliness Of The Staff",
        //   description: "How friendly was the staff?",
        //   rating: 0,
        // },
        // {
        //   key: "attentiveness",
        //   heading: "Attentiveness",
        //   description: "How well did your doctor listen to your concerns?",
        //   rating: 0,
        // },
        // {
        //   key: "quality_time",
        //   heading: "Quality Time",
        //   description: "Did you feel that your doctor spent enough time with you?",
        //   rating: 0,
        // },
        // {
        //   key: "politeness",
        //   heading: "Politeness",
        //   description: "How polite was your doctor?",
        //   rating: 0,
        // },
        // {
        //   key: "knowledge",
        //   heading: "Knowledge",
        //   description: "How well did your doctor explain your medical condition to you?",
        //   rating: 0,
        // },
        // // {
        // //   key: "cost_of_appointment",
        // //   heading: "Cost of consultation",
        // //   description: "Is the cost of consultation of the telemedicine services affordable?",
        // //   rating: 0,
        // // },
        // // {
        // //   key: "ease_of_use_of_technology",
        // //   heading: "Ease of use of technology",
        // //   description: "Is the telemedicine platform easy and comfortable to use?",
        // //   rating: 0,
        // // },
        // // {
        // //   key: "knowledge_ability",
        // //   heading: "Knowledgeability",
        // //   description: "Is the healthcare provider knowledgeable in his/her area of expertise?",
        // //   rating: 0,
        // // },
        // // {
        // //   key: "satisfaction",
        // //   heading: "Satisfaction",
        // //   description: "Are you satisfied with the consultation and level of interaction using the telemedicine platform?",
        // //   rating: 0,
        // // },
        // // {
        // //   key: "compassion",
        // //   heading: "Compassion",
        // //   description: "Did the healthcare provider show care and concern while interacting on the platform?",
        // //   rating: 0,
        // // },
        // {
        //   key: "description",
        //   heading: "Few words can be really powerful",
        //   description: " - OPTIONAL",
        //   rating: null,
        // },
      ],
      onlineReviews: [
        {
          key: "cost_of_appointment",
          heading: "Cost of consultation",
          description:
            "Is the cost of consultation of the telemedicine services affordable?",
          rating: 0,
        },
        {
          key: "ease_of_use_of_technology",
          heading: "Ease of use of technology",
          description:
            "Is the telemedicine platform easy and comfortable to use?",
          rating: 0,
        },
        {
          key: "knowledge_ability",
          heading: "Knowledgeability",
          description:
            "Is the healthcare provider knowledgeable in his/her area of expertise?",
          rating: 0,
        },
        {
          key: "satisfaction",
          heading: "Satisfaction",
          description:
            "Are you satisfied with the consultation and level of interaction using the telemedicine platform?",
          rating: 0,
        },
        {
          key: "compassion",
          heading: "Compassion",
          description:
            "Did the healthcare provider show care and concern while interacting on the platform?",
          rating: 0,
        },
        {
          key: "description",
          heading: "Few words can be really powerful",
          description: " - OPTIONAL",
          rating: null,
        },
      ],
      reviewComplete: false,
      currentReview: 0,
      currentPage: 0,
      formResponses: {
        option: 1,
        description: "",
      },
      mobile: { margin: "0px", top: "0px", height: "100vh" },
      web: { top: "0px", height: "100vh ", width: "1000px !important" },
      hm: 0,
      visitLength: null,
    };
  },
  computed: {
    SSO_BASE_URL: () => process.env.SSO_BASE_URL,
  },
  created() {
    this.finalPopSize = this.screenSize < 581 ? this.mobile : this.web;
    if (["physician", "doctor"].includes(this.selectedDoctorProfile.role)) {
      this.inPersonReviews = [
        {
          key: "appointment",
          heading: "Ease of Appointment",
          description: "How easy was is to schedule an appointment?",
          rating: 0,
        },
        {
          key: "wait_time",
          heading: "Wait Time",
          description:
            "How satisifed were you about the wait time before seeing a doctor?",
          rating: 0,
        },
        {
          key: "friendliness",
          heading: "Friendliness Of The Staff",
          description: "How friendly was the staff?",
          rating: 0,
        },
        {
          key: "attentiveness",
          heading: "Attentiveness",
          description: "How well did your doctor listen to your concerns?",
          rating: 0,
        },
        {
          key: "quality_time",
          heading: "Quality Time",
          description:
            "Did you feel that your doctor spent enough time with you?",
          rating: 0,
        },
        {
          key: "politeness",
          heading: "Politeness",
          description: "How polite was your doctor?",
          rating: 0,
        },
        {
          key: "knowledge",
          heading: "Knowledge",
          description:
            "How well did your doctor explain your medical condition to you?",
          rating: 0,
        },
        {
          key: "length_of_visit",
          heading: "Length of Visit",
          description: "How much time did you spend with your doctor?",
          rating: 0,
        },
        {
          key: "comment",
          heading: "Few words can be really powerful",
          description: " - OPTIONAL",
          rating: "",
          // rating: null,
        },
      ];
    } else {
      this.inPersonReviews = [
        {
          key: "appointment",
          heading: "Ease of Appointment",
          description: "How easy was is to schedule an appointment?",
          rating: 0,
        },
        {
          key: "wait_time",
          heading: "Wait Time",
          description:
            "How satisifed were you about the wait time before seeing a doctor?",
          rating: 0,
        },
        {
          key: "friendliness_of_staff",
          heading: "Friendliness Of The Staff",
          description: "How friendly was the staff?",
          rating: 0,
        },
        {
          key: "attentiveness",
          heading: "Attentiveness",
          description: "How well did your doctor listen to your concerns?",
          rating: 0,
        },
        {
          key: "quality_time",
          heading: "Quality Time",
          description:
            "Did you feel that your doctor spent enough time with you?",
          rating: 0,
        },
        {
          key: "politeness",
          heading: "Politeness",
          description: "How polite was your doctor?",
          rating: 0,
        },
        {
          key: "knowledge",
          heading: "Knowledge",
          description:
            "How well did your doctor explain your medical condition to you?",
          rating: 0,
        },
        {
          key: "length_of_visit",
          heading: "Length of Visit",
          description: "How much time did you spend with your doctor?",
          rating: 0,
        },
        {
          key: "comment",
          heading: "Few words can be really powerful",
          description: " - OPTIONAL",
          // rating: null,
          rating: "",
        },
      ];
    }
  },
  methods: {
    handleLengthVisit(val) {
      this.visitLength = val;
      this.currentReview = this.currentReview + 1;
    },
    handleCloseReview() {
      this.$router.go(0);
      this.hide();
      this.reviewComplete = false;
      this.typeOfReview = "none";
      this.currentReview = 0;
      // this.viewProfile({
      //   role: this.selectedDoctorProfile.role,
      //   id: this.selectedDoctorProfile.id
      // });
      // if (this.viewUser) {
      //   if (this.selectedDoctorProfile.role === "doctor" || this.selectedDoctorProfile.role === "hcp" || this.selectedDoctorProfile.role === "physician") {
      //     this.viewProfile({
      //       role: this.selectedDoctorProfile.role,
      //       id: this.selectedDoctorProfile.id,
      //     })
      //   } else {
      //     this.selectedDoctorProfile.ext_ref_id ? this.viewEntityProfile(this.selectedDoctorProfile) : this.viewProfile(this.selectedDoctorProfile)
      //   }
      // }
      // if (
      //   this.selectedDoctorProfile.role === "doctor" ||
      //   this.selectedDoctorProfile.role === "hcp"
      // ) {
      //   this.selectedDoctorProfile.ext_ref_id
      //     ? this.viewEntityProfile(this.selectedDoctorProfile)
      //     : this.viewProfile(this.selectedDoctorProfile);
      // }
      console.log("CLOSE REVIEW");
    },
    handleModalOk() {
      this.showModal = false;
    },
    handleModalClose() {
      this.showModal = false;
      setTimeout(() => {
        this.typeOfReview = "none";
        this.currentReview = 0;
      }, 500);
      // this.viewProfile(this.selectedDoctorProfile);
    },
    show(data, selectedType = "none") {
      this.showModal = true;
      this.selectedDoctorProfile = { ...data, inPersonReview: false };
      console.log("this.viewUser ->", this.viewUser);
      console.log("this.selectedDoctorProfile ->", this.selectedDoctorProfile);
    },
    setTypeOfReview(reviewType) {
      // if (this.viewUser) {
      //   if (!this.viewUser[reviewType + "Review"])
      //     this.typeOfReview = reviewType;
      // } else {
      //   if (!this.selectedDoctorProfile[reviewType + "Review"])
      //     this.typeOfReview = reviewType;
      // }
      if (!this.selectedDoctorProfile[reviewType + "Review"])
        this.typeOfReview = reviewType;
    },
    getHoverType(i, index, reviewType) {
      if (!reviewType[index].rating) {
        this.geth = this.ratingConverter(i);
        this.hm = document.getElementsByClassName("star-rating-recommend");
        for (let j = 0; j < 5; j++) {
          if (j < i) {
            this.hm[j].classList.remove("silver");
            this.hm[j].classList.add("golden");
          } else {
            this.hm[j].classList.add("silver");
            this.hm[j].classList.remove("golden");
          }
        }
      }
    },
    getHover(i, index) {
      switch (this.typeOfReview) {
        case "online":
          this.getHoverType(i, index, this.onlineReviews);
          break;
        case "myCircles":
          this.getHoverType(i, index, this.myCircleReviews);
          break;
        case "inPerson":
          this.getHoverType(i, index, this.inPersonReviews);
          break;
      }
    },
    removeHoverType(index, reviewType) {
      this.geth = null;
      this.hm = document.getElementsByClassName("star-rating-recommend");
      if (!reviewType[index].rating) {
        for (let j = 0; j < 5; j++) {
          this.hm[j].classList.add("silver");
          this.hm[j].classList.remove("golden");
        }
      }
      this.hm = 0;
    },
    removeHover(index) {
      switch (this.typeOfReview) {
        case "online":
          this.removeHoverType(index, this.onlineReviews);
          break;
        case "myCircles":
          this.removeHoverType(index, this.myCircleReviews);
          break;
        case "inPerson":
          this.removeHoverType(index, this.inPersonReviews);
          break;
      }
    },
    ratingConverter(num) {
      const array = [" ", "WORST", "POOR", "AVERAGE", "GOOD", "EXCELLENT"];
      return array[num];
    },
    putRating(i) {
      this.geth = null;
      switch (this.typeOfReview) {
        case "online":
          this.onlineReviews[this.currentReview].rating = i;
          if (!this.reviewStarClicked) {
            this.reviewStarClicked = true;
            setTimeout(() => {
              this.currentReview =
                this.currentReview + 1 < this.onlineReviews.length
                  ? this.currentReview + 1
                  : this.currentReview;
              this.reviewStarClicked = false;
            }, 500);
          }
          break;
        case "myCircles":
          this.myCircleReviews[this.currentReview].rating = i;
          if (!this.reviewStarClicked) {
            this.reviewStarClicked = true;
            setTimeout(() => {
              this.currentReview =
                this.currentReview + 1 < this.myCircleReviews.length
                  ? this.currentReview + 1
                  : this.currentReview;
              this.reviewStarClicked = false;
            }, 500);
          }
          break;
        case "inPerson":
          this.inPersonReviews[this.currentReview].rating = i;
          if (!this.reviewStarClicked) {
            this.reviewStarClicked = true;
            setTimeout(() => {
              this.currentReview =
                this.currentReview + 1 < this.inPersonReviews.length
                  ? this.currentReview + 1
                  : this.currentReview;
              this.reviewStarClicked = false;
            }, 500);
          }
          break;
      }
      // console.log("currentReview ->", this.currentReview)
    },
    hide() {
      this.showModal = false;
    },
    getReviewerLabel() {
      // switch (this.selectedDoctorProfile.role) {
      //   case "doctor":
      //   case "physician":
      //     // return `Dr. ${this.selectedDoctorProfile.first_name} ${this.selectedDoctorProfile.last_name},
      //     //   ${this.selectedDoctorProfile.title || ""}`
      //     return this.selectedDoctorProfile.display_name || "Doctor";
      //   // return `${this.selectedDoctorProfile.first_name} ${this.selectedDoctorProfile.last_name}, ${this.selectedDoctorProfile.title || ""}`;
      //   case "other":
      //   case "hcp":
      //   case "ohcp":
      //   case "ahcp":
      //     return `${this.selectedDoctorProfile.display_name}`;
      //   // return `${this.selectedDoctorProfile.first_name} ${this.selectedDoctorProfile.last_name}`;
      //   default:
      //     return `${this.selectedDoctorProfile.first_name} ${this.selectedDoctorProfile.last_name}`;
      // }
      return this.selectedDoctorProfile.display_name
        ? this.selectedDoctorProfile.display_name
        : this.selectedDoctorProfile.role === "hcp"
        ? this.selectedDoctorProfile.hcp_info.full_name +
          (this.selectedDoctorProfile.title != null
            ? ", " + this.selectedDoctorProfile.title
            : "")
        : this.selectedDoctorProfile.doctor_info.full_name +
          (this.selectedDoctorProfile.title != null
            ? ", " + this.selectedDoctorProfile.title
            : "");
    },
    getEntityImage() {
      switch (this.selectedDoctorProfile.role) {
        case "doctor":
        case "physician":
          let default_image =
            "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/";
          default_image +=
            !this.selectedDoctorProfile.gender ||
            this.selectedDoctorProfile.gender.toLowerCase() === "m" ||
            this.selectedDoctorProfile.gender.toLowerCase() === "male"
              ? "MALE DOCTOR2x.png"
              : "WOMAN DOCTOR2x.png";
          return (
            this.selectedDoctorProfile.picture ||
            this.selectedDoctorProfile.url ||
            default_image
          );
        case "other":
        case "hcp":
        case "ohcp":
        case "ahcp":
          let default_other =
            "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/";
          default_other += (
            this.selectedDoctorProfile.hcp_info
              ? !this.selectedDoctorProfile.hcp_info.gender ||
                this.selectedDoctorProfile.hcp_info.gender.toLowerCase() ===
                  "m" ||
                this.selectedDoctorProfile.hcp_info.gender.toLowerCase() ===
                  "male"
              : !this.selectedDoctorProfile.gender ||
                this.selectedDoctorProfile.gender.toLowerCase() === "m" ||
                this.selectedDoctorProfile.gender.toLowerCase() === "male" ||
                !this.selectedDoctorProfile.gender
          )
            ? "MALE DOCTOR2x.png"
            : "WOMAN DOCTOR2x.png";
          return this.selectedDoctorProfile.hcp_info
            ? this.selectedDoctorProfile.hcp_info.picture || default_other
            : this.selectedDoctorProfile.url || default_other;
        default:
          return "";
      }
    },
    recommendType(currentReviewType, currentReviewArray) {
      if (this.submitting) {
        return;
      }
      const payload = {};
      let rate = 0;
      currentReviewArray.forEach((rev, i) => {
        if (rev.key === "length_of_visit") {
          payload[rev.key] = this.visitLength;
        } else {
          payload[rev.key] = rev.rating;
          if (i < currentReviewArray.length - 1) {
            rate = rate + rev.rating;
          }
        }
      });

      //             "published": "datetime",
      //             "wait_time": "float",
      //             "friendliness": "float",
      //             "attentiveness": "float",
      //             "review_color": "string",
      //             "quality_time": "float",
      //             "politeness": "float",
      //             "knowledge": "float",
      //             "comment": "string",
      //             "appointment": "float",
      //             "length_of_visit": [
      //                 "lt15",
      //                 "lt30",
      //                 "hour"
      //             ]

      if (currentReviewType === "InPerson") {
        const headers = {
          Authorization: `Basic ${btoa("dovemed:dovemed-rules")}`,
          dtoken:
            this.authUser.user.dovemed_csrf_token ||
            this.authUser.user.dovemed_session_token,
        };
        this.submitting = true;
        this.$http
          .post(
            `${
              process.env.SSO_BASE_URL
            }/api/v2/review/${this.getCoreReviewApiRole(
              this.selectedDoctorProfile.role
            )}/${this.selectedDoctorProfile.ext_ref_id}/review/`,
            payload,
            { headers }
          )
          // .post(`${process.env.SSO_BASE_URL}/api/v2/${this.getCoreReviewApiRole(this.selectedDoctorProfile.role)}/${this.selectedDoctorProfile.ext_ref_id}/review/`, payload, { headers })
          .then((res) => {
            this.submitting = false;
            this.$store.commit("User/setToggleReview");
            this.reviewComplete = true;
            this.docRating = (rate / (currentReviewArray.length - 2)).toFixed(
              1
            );
          })
          .catch((e) => {
            this.submitting = false;
            this.$notification.error({
              message: "Failed",
              description: "Try Again",
            });
            console.log("error: ", e);
            console.log(e.message);
            UserRepository.recordLogout();
            this.$store.dispatch("Auth/logout").then(() => {
              location.reload();
            });
          });
      } else {
        payload["type"] = currentReviewType;
        payload["rating"] = Number(
          (rate / (currentReviewArray.length - 1)).toFixed(1)
        );
        payload["user"] = this.authUser.user.id;
        payload["reviewer_id"] = this.authUser.user.id;
        payload["user_circle"] = this.currentCircle.id;
        payload["circle_id"] = this.currentCircle.id;
        payload["reviewer_role"] =
          this.authUser.user.role || this.getRoleOfCurrentCircle();

        if (
          this.selectedDoctorProfile.role == "doctor" ||
          this.selectedDoctorProfile.role == "physician"
        ) {
          payload["doctor"] =
            this.selectedDoctorProfile.is_virtual ||
            this.selectedDoctorProfile.ext_ref_id
              ? this.selectedDoctorProfile.ext_ref_id
              : this.selectedDoctorProfile.id;
          payload["ext_ref_id"] = this.selectedDoctorProfile.ext_ref_id;
          payload["reviewee_id"] = this.selectedDoctorProfile.ext_ref_id;
          payload["reviewee_role"] = this.selectedDoctorProfile.role;
        } else if (
          this.selectedDoctorProfile.role == "hcp" ||
          this.selectedDoctorProfile.role == "ohcp" ||
          this.selectedDoctorProfile.role == "other"
        ) {
          payload["hcp"] = this.selectedDoctorProfile.is_virtual
            ? null
            : this.selectedDoctorProfile.id;
          payload["ext_ref_id"] = this.selectedDoctorProfile.ext_ref_id;
          payload["reviewee_id"] = this.selectedDoctorProfile.ext_ref_id;
          payload["reviewee_role"] = "hcp";
        } else {
          // console.log("ROLE ->", this.selectedDoctorProfile.role)
        }

        this.submitting = true;
        UserRepository.reviewEntityBasedOnType(
          payload,
          this.selectedDoctorProfile.role
        )
          .then((res) => {
            this.submitting = false;
            this.$store.commit("User/setToggleReview");
            if (res.data) {
              // const newPayload = {}
              // const page = 0
              // newPayload.page = this.selectedDoctorProfile.page ? this.selectedDoctorProfile.page - 1 : 0
              // newPayload.circle_id = this.currentCircle.id
              // this.$store.dispatch("Signup/getDoctors", newPayload)
              // this.fetchUser(this.selectedDoctorProfile.page)
              this.reviewComplete = true;
              this.docRating = (rate / (currentReviewArray.length - 1)).toFixed(
                1
              );
              // if (
              //   this.selectedDoctorProfile.role === "doctor" ||
              //   this.selectedDoctorProfile.role === "hcp"
              // ) {
              //   this.selectedDoctorProfile.ext_ref_id
              //     ? this.viewEntityProfile(this.selectedDoctorProfile)
              //     : this.viewProfile(this.selectedDoctorProfile);
              // }
            }
          })
          .catch((err) => {
            this.submitting = false;
            this.$notification.error({
              message: "Failed",
              description: "Try Again Later",
            });
          });
      }
    },
    recommend() {
      switch (this.typeOfReview) {
        case "online":
          this.recommendType("Online", this.onlineReviews);
          break;
        case "inPerson":
          this.recommendType("InPerson", this.inPersonReviews);
          break;
        case "myCircles":
          this.recommendType("MyCircles", this.myCircleReviews);
          break;
      }
    },
    getRoleOfCurrentCircle() {
      let role = "";
      if (this.authUser.user.multiRole.length > 0) {
        this.authUser.user.multiRole.forEach((eachRole) => {
          if (eachRole.circle_id === this.currentCircle.id) {
            role = eachRole.role;
          }
        });
      }
      return role;
    },
    checkDisabled(type) {
      // return this.viewUser
      //   ? this.viewUser[type + "Review"]
      //     ? "disabledCard"
      //     : ""
      //   : this.selectedDoctorProfile[type + "Review"]
      //   ? "disabledCard"
      //   : "";
      return this.selectedDoctorProfile[type + "Review"]
        ? "disabledCard"
        : "enabledCard";
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  .treatment-modal .ant-modal-centered .ant-modal {
    width: 100vw !important;
    margin: 0 !important;
    height: 100vh;
  }
  .input-type {
    font-size: 12px;
    padding: 0px;
  }
  .input-treatment-name {
    width: 80%;
  }
  .date-picker {
    width: 100%;
  }
  .currently-using {
    display: inline;
  }
  .date-picker {
    width: 50px;
  }
}

.ant-modal-centered .ant-modal {
  height: 100vh !important ;
  width: auto !important;
}

.ant-modal {
  width: auto !important;
  margin: 0px !important;
  padding: 0 !important;

  @media screen and (max-width: 767px) {
    margin: 0px !important;
  }
}

.ant-modal-wrap {
  overflow: hidden !important;
}

// .blue-part {
//   @media screen and (max-width: 700px) {
//     min-height: 35vh;
//   }
// }
.white-container {
  width: 100%;
  @media screen and (max-width: 700px) {
    margin: 0 auto;
    width: auto;
  }
  .white-part {
    @media screen and (max-width: 700px) {
      min-height: 50vh;
      background: #ffffff;
      border-radius: 8px;
      padding: 20px;
      margin-bottom: 20px;
    }
  }
}
.selected-profile-name {
  @media screen and (max-width: 900px) {
    max-width: 100%;
  }
}
.end-height {
  @media screen and (max-width: 900px) {
    height: 80vh;
  }
}
.recommend-container {
  @media screen and (max-width: 700px) {
    background: #0f74bd;
    min-height: 100vh;
  }
}

.reviewTypeContainer {
  max-width: 400px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  text-align: left;
  margin-top: 24px;
}

.reviewMainHeader {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  width: 304px;
  margin: auto;
  text-align: center;
  margin-top: 20px;
}

.reviewTypeCard {
  background-color: #f1f5f9;
  padding: 24px;
  border-radius: 4px;
  cursor: pointer;
}

.enabledCard:hover {
  background-color: #e4edf7;
}

.reviewTypeTitle {
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  color: #1e2945 !important;
}

.reviewTypeDescription {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #647490 !important;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 25px;
}

.guidelines {
  margin-top: 100px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  text-decoration-line: underline;
  color: #ffffff !important;
}

.reviewRightFooter {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #647490;
}

.arrow-icon {
  color: #2a71d4;
  height: 15px;
  width: 15px;
}

.disabledCard {
  cursor: auto;
  opacity: 0.5;
  // background-color: #F1F5F9;
  // &:hover {
  //   background-color: #F1F5F9;
  // }
  // h1.reviewTypeTitle {
  //   color: #888888 !important;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/RecommendDoctor.vue